// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3zNst","alertIcon":"ConfirmModal_alertIcon__3Ri1M"};